import React from 'react';
import { connect } from 'react-redux';

import AttachedGoods from '../Good/AttachedGoods';
import PaySection from '../PaySection/PaySection';
import Button from '../../components/Button/Button';
import s from './Product.module.scss';

const Product = props => {
  const { good, t } = props;
  if (!good.locData || !t.language) return null;
  const goodData = good.locData[t.language];
  if (!goodData) return null;
  const goodImage = good.img;

  return (
    <div className={s.main}>
      <div className={s.header}>
        <a href={`/good/${good.seo_url || good.id}`}>
          <h3>{goodData.name}</h3>
        </a>
        <div className={s.descriptionPreview}>
          {goodData.description_preview}
        </div>
      </div>
      <div className={s.productContent}>
        <div className={s.imgageGood} title={goodImage.title}>
          <div className={s.thumbnail}>
            <a href={`/good/${good.seo_url || good.id}`} className={s.btnWhite}>
              <img
                src={goodImage.src}
                alt={goodImage.alt}
                title={goodImage.title}
              />
            </a>
          </div>
        </div>
        <div className={s.description}>
          <div className={s.payDiv}>
            <PaySection id={good.id} />
          </div>
          <a href={`/good/${good.seo_url || good.id}`} className={s.btnWhite}>
            <Button
              btnStyle={{
                color: '#669900',
                hoverColor: '#568200',
                backgroundColor: '#fff',
                borderColor: '#669900',
                hoverBackgroundColor: '#fff',
                hoverBorderColor: '#568200'
              }}
              btnOptions={{
                size: 'small'
              }}
              text={t['Подробнее']}
            />
          </a>
          <AttachedGoods product={goodData} />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = state => ({
  t: state.translation
});

export default connect(mapStateToProps)(Product);
